import React, { Component } from 'react';
import $ from 'jquery';

import AdminLayout from './layout';

import FetchCall from '../../API/FetchCall';
import { getMail, sendCustomMail } from '../../API/FetchCall';
//import { Editor } from '@tinymce/tinymce-react';

import { EditorState, convertToRaw, convertFromHTML, convertFromRaw, ContentState } from 'draft-js';

import { Editor } from '@tinymce/tinymce-react';
import { TINY_EDITOR } from '../../constant';

import axios from 'axios';

class customMails extends Component {

    constructor(props) {
        super(props);
        this.state = {
          errors: [],
          mailDetail: '',
          mail_name:'',
          mail_content:'',
          mail_subject:'',
          email_address:'',
          ifthisemailaddress:false,
          to:'',
          editorState: EditorState.createEmpty()
        };
        
        this.id = this.props.match.params.id ? this.props.match.params.id : '';
        //this.getMail = this.getMail.bind(this);
        this.sendMail = this.sendMail.bind(this);
        this.handleEditorChange = this.handleEditorChange.bind(this);
    }


    componentDidMount() {

      
    }


    sendMail = ()=>{
          
       // let contentState = this.state.editorState.getCurrentContent();
        console.log("when saving..", this.state.consigne);


        let req = JSON.stringify({
            mail_name:this.state.mail_template,
            mail_subject:this.state.mail_subject,  
            mail_content: this.state.mail_content,
            to:this.state.to,
            email_address:this.state.email_address          
        })

        
        sendCustomMail(req).then((response) => {
          
          if(response.status==1){

                alert(response.message);
                

          }else{
                alert(response.message);
          }
      
        });
       

    }


    uploadImageCallBack = (e) => {
        const propName = e.target.name;
        var files = e.target.files;
        this.setState({
          [propName]: files
        });
      };

 
    handleChange = (e) => {

      this.setState({ [e.target.name]: e.target.value });
      if(e.target.name=='to' && e.target.value=='individual'){
          this.setState({ifthisemailaddress:true});
      }
      
    };

    handleEditorChange(value, editor) {
        this.setState({
            mail_content: value
        });
      }
  

    render() {

        const { mail_content, editorState, consigne, ifthisemailaddress} = this.state;


 
        return (
            <React.Fragment>
                <AdminLayout>
                    
                       <div class="col-12 grid-margin">
              <div class="card">
                <div class="card-body">
                  <h4 class="card-title">Mail - Edit</h4>
                  <form class="form-sample">
                    
                    <div class="row">

                      <div class="col-md-6">
                        <div class="form-group row">
                          <label class="col-sm-3 col-form-label">Mail Name</label>
                          <div class="col-sm-9">
                            <input type="text" class="form-control" name="mail_name" value={this.state.mail_name} onChange={this.handleChange} />
                          </div>
                        </div>
                      </div>

                      <div class="col-md-6">
                        <div class="form-group row">
                          <label class="col-sm-3 col-form-label">Mail Subject</label>
                          <div class="col-sm-9">
                            <input type="text" class="form-control" name="mail_subject" value={this.state.mail_subject} onChange={this.handleChange} />
                          </div>
                        </div>
                      </div>
                      <div class="col-md-6">
                        <div class="form-group row">
                          <label class="col-sm-3 col-form-label">To</label>
                          <div class="col-sm-9">
                            <select class="form-control" name="to"  value={this.state.to} onChange={this.handleChange}>
                              <option value="parents">Parent</option>
                              <option value="partners">Partner</option>
                              <option value="teachers">Teachers</option>
                              <option value="individual">Individual Mail id</option>
                            </select>
                          </div>
                        </div>
                      </div>
                      { ifthisemailaddress &&
                      <div class="col-md-6">
                      <div class="form-group row">
                        <label class="col-sm-3 col-form-label">Email Address</label>
                        <div class="col-sm-9">
                          <input type="text" class="form-control" name="email_address" value={this.state.email_address} onChange={this.handleChange} />
                        </div>
                      </div>
                      </div>
                      }

                    </div>
                    
                    <div class="row">
                     
                      <div class="col-md-12">
                        <div class="form-group row">
                          <label class="col-sm-3 col-form-label">Mail Content</label>
                          <div class="col-sm-12">
                          <Editor
                            onEditorChange={this.handleEditorChange}
                            toolbar={{
                                inline: { inDropdown: true },
                                list: { inDropdown: true },
                                textAlign: { inDropdown: true },
                                link: { inDropdown: true },
                                history: { inDropdown: true },
                                image: { uploadCallback: this.uploadImageCallBack, alt: { present: true, mandatory: true } },
                              }}
                            value={this.state.insight_content}
                            name="insight_content"
                            apiKey={TINY_EDITOR}
                            init={{
                                  height: 300,
                                  theme:"silver",
                                  plugins: ["advlist autolink lists link anchor paste image"],
                                  file_picker_types: "file image media",
                                  toolbar: 'undo redo | formatselect | image| bold italic | alignleft aligncenter alignright alignjustify | bullist numlist outdent indent | help',
                                  //images_upload_handler: uploadImageCallBackServer
                                  images_upload_handler: async function(
                                                                          blobInfo:any,
                                                                          success: any,
                                                                          failure: any
                                                                        ) {
                                                                          let imageFile = new FormData();
                                                                          //imageFile.append("files[]", blobInfo.blob());
                                                                          imageFile.append('image', blobInfo.blob());
                                                                          try {
                                                                            const {data} = await axios.post("https://api.bewise.in/api/campaign/mail/uploadeditorimage", imageFile)
                                                                            success(data.data.link);
                                                                          } catch (error) {
                                                                            console.log(error);
                                                                            return;
                                                                          }
                                                                        }
                            }}
                   
                          />
                          </div>
                           
                        </div>
                      </div>
                    </div>
                     
                    <div class="row">
                      <div class="col-md-12">
                        <div className="row mb-4 text-right">
                          <button type='button' id="btnSubmit"
                            className="btn btn-primary btn-sm" onClick={this.sendMail} style={{ display: "block", margin: "auto" }}>
                            Submit
                          </button>
                        </div>
                       
                      </div>
                    </div> 
                    
                  </form>
                </div>
              </div>
            </div>  


                </AdminLayout>
            </React.Fragment>
        )
    }
}


export default customMails;


// WEBPACK FOOTER //
// ./src/components/bewise/customMails.jsx